// extracted by mini-css-extract-plugin
export var discard = "_5l-3";
export var muiTooltipTooltip = "_5l-5";
export var notificationBar = "_5l-2";
export var saveButtonHoverSlotWrapper = "_5l-4";
export var show = "_5l-1";
export var spacer = "_5l-0";